<template>
  <div>
    <evaluationModal v-if="showEvaluation" @closeModal="closeEvaluation" @submitData="submitEvaluation"></evaluationModal>
    <div id="secTop">
      <personal :info="caseInfo" :keys="100"></personal>
      <orderModal v-if="showOrder" :caseTrans="caseInfo" :caseId="$route.params.id" @close="closeOrder"></orderModal>
      <div class="operate-area">
        <mu-raised-button label="现场测评" @click="openEvaluation" style="color:#fff; border-radius:40px;background-color: #1bbe9f"  />
        <trainScene :caseID="$route.params.id" :showFlag="2"></trainScene>
       <!--  <mu-raised-button v-if="$route.query.status == 1" label="新建订单" class="button" @click="showOrder=true" style="color:#999;height:36px;border-radius:36px;" /> -->
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import store from '../../../store/index.js'
  import trainScene from '../../common/train/trainScene.vue'
  import evaluationModal from './evalRecord/evaluationModal.vue'
  import orderModal from '../order/orderModal.vue'
  import personal from '../../common/personal.vue'
  import {getSelect} from '../../../assets/js/common.js'

  export default ({
    props: ['caseInfo'],
    data(){
      return{
        showEvaluation: false,  // 显示现场测评
        showOrder: false
      }
    },
    components:{
      evaluationModal,
      personal,
      trainScene,
      orderModal
    },
    computed: {
      showName: function(){
        var names = this.caseInfo.name+'';
        var len = names.split('').length;
        if(len <2){
          return names;
        } else {
          return names.split('')[len-2]+names.split('')[len-1]
        }
      },
      sex: function() {
        return getSelect('gender', this.caseInfo.gender)
      }
    },
    methods: {
      submitEvaluation: function(res) {
        if (res.length == 0) {
          alert('請選擇訓練項目');
        } else {
          this.gameData = res;
          this.saveGame = true;
          this.showEvaluation = false;
        }
      },
      openEvaluation:function(){
        this.showEvaluation=true;
        $(".controlOverflow").css("overflow","");
      },
      // 再练习一次
      closeEvaluation:function(){
        this.showEvaluation=false;
        $(".controlOverflow").css("overflow","auto");
      },
      closeOrder: function(val){
        this.showOrder=false;
        // 刷新vuex中的状态数据，便于兄弟组件更新
        this.$store.commit("changeOrder",1);
      }
    }
  })
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  @import "../../../assets/css/app.styl";
  @import "../../../assets/css/variable.styl";
  #secTop
    height 64px
    display flex
    justify-content space-between
    align-items center
    text-align center
    color #fff
    border-bottom 1px solid #dedede
  .nameCircular
    height 48px
    width 48px
    line-height 48px
    background-color #1BBE9F
    color #fff
    text-align center
    border-radius 50%
    margin-right 20px
  .operate-area
    display flex
    justify-content space-between
    align-items center
    padding-right 40px
    button
      margin-left 20px
</style>



// WEBPACK FOOTER //
// secondtop.vue?775f5e8c